import { render, staticRenderFns } from "./SelectionCompany.vue?vue&type=template&id=51e7f798&scoped=true&"
import script from "./SelectionCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectionCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7f798",
  null
  
)

export default component.exports